<template>
	<div class="doc-detail fontFam" :style="getBoxStyle" :class="{mobileDocDetail:isMobile}">
		<div class="refTitle" :style="getTitleStyle">
			<div class="source" v-if="sourceData.fileIcon">
				<div class="left">
					<div class="icon">
						<div class="lowImage" v-if="sourceData.fileIcon">
							<img :src="sourceData.fileIcon" v-if="/(https?:\/\/[^\s]+(\.[^\s]+){1,})/g.test(sourceData.fileIcon)" class="image" alt="" />
							<span v-else>
								{{ sourceData.fileIcon }}
							</span>
						</div>
					</div>
					<span class="label" v-if="sourceData.fileSource">{{ sourceData.fileSource }}</span>
				</div>
			</div>
			<div class="defaultURlIcon" v-else-if="!sourceData.fileIcon&&fileType=='url'">
				<div class="icon">
					<CoolFujianA97412md size="14"  color="#fff"></CoolFujianA97412md>
				</div>
				<div class="link">{{ sourceData.fileUrl }}</div>
				
			</div>
			<div class="titleLine">
				<div class="title fontFamWeight" @click="openLink(sourceData)">
					{{ sourceData.fileName }}
				</div>
				<div class="arrow"><CoolJiantouyou  size="15" color="#646479"/></div>
			</div>
		</div>
		<div class="content" v-if="fileType === 'img' && sourceData.fileUrl">
			<img class="source-img" :src="sourceData.fileUrl" alt="" />
		</div>
		<div class="content" v-else-if="context[sourceIndex]"  :class="{docContent:fileType!='url'}">
			
			<div class="ragList">
				<div class="ragItem">
					<div class="text">
						<div class="markdown">
							<p v-html="context[sourceIndex] "></p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bottomPlace"></div>
		<div class="bgc-logo" :class="{ smalllogo: !sourceData.fileIcon||!context[sourceIndex] }">
			<img :src="imageUrlIcon()" />
		</div>
	</div>
</template>
   
  <script setup lang="ts">
import { h, ref, defineProps, computed, onMounted } from 'vue';
import { useChatStore } from '/@/stores/chat';
import url from '/@common/assets/url.png';
import axios from 'axios';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
const { isMobile } = useBasicLayout();
interface Props {
	sourceIndex?: number;
	sourceData?: {};
}
const props = defineProps<Props>();
const chatStore = useChatStore();
onMounted(() => {
});
const getBoxStyle = computed(() => {
	let isUrl = fileType.value == 'url' ? true : false;
	return {
		background: isUrl ? 'linear-gradient( 180deg, #E4EFFF 0%, #FFFFFF 25%)' : '#fff',
		padding: isUrl ? '0px' : '2px',
	};
});
const context = computed(() => {
	return JSON.parse(props.sourceData?.paragraphs || '[]');
});
const fileIcon = computed(() => {
	if (sourceData.fileIcon) {
		const reg = /(https?:\/\/[^\s]+(\.[^\s]+){1,})/g;
		if (reg.test(text)) {
			return sourceData.fileIcon;
		}
	}

	return sourceData.fileIcon;
});
const openLink = (item:object) => {
	let fileTypes=['txt','doc','docx','ppt','pptx','pdf','png','jpg','jpeg','xlsx','xls']
	if(item.fileType&&fileTypes.includes(item.fileType.toLowerCase())){
		let data={
		url:item.fileUrl,
		type:item.fileType.toLowerCase(),
		name:item.fileName,
	}
	chatStore.previewFlag=true
	chatStore.previdewData=data
	}else{
		window.open(item.fileUrl, '_blank');
	}
};
const downloadFile =  (url:string) => {
	axios.get(url, {responseType: 'blob'}).then((response) => {
		const blob = new Blob([response.data], { type: 'application/;charset=utf-8' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = props.sourceData.fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
	})
};
const fileType = computed(() => {
	if (props.sourceData.type) {
		const imgLists = ['png', 'jpg', 'jpeg'];
		if(props.sourceData.fileType&&imgLists.includes(props.sourceData.fileType.toLowerCase())){
			return 'img'
		}	
		return props.sourceData.type == 'WEB' ? 'url' : props.sourceData.fileType;
	} else {
		return getFileExtension(props.sourceData.fileName);
	}
});
const imageUrlIcon = () => {
	let obj = {
		pdf: 'pdf',
		docx: 'word',
		doc: 'word',
		ppt: 'ppt',
		pptx: 'ppt',
		md: 'md',
		txt: 'txt',
		url: 'url',
		img:'img'
	};
	return new URL(`../../assets/chat/${obj[fileType.value] || 'more'}.png`, import.meta.url).href;
};
const getFileExtension = (filename: string) => {
	var match = filename.match(/(?:\.([^.]+))$/);
	return match ? match[1] : '';
};
const getTitleStyle = computed(() => {
	let backObj = {
		pdf: 'rgba(245, 75, 91, .06)',
		docx: 'rgba(53, 94, 255, .06)',
		doc: 'rgba(53, 94, 255, .06)',
		ppt: 'rgba(255, 98, 0, .06)',
		pptx: 'rgba(255, 98, 0, .06)',
		md: 'rgba(21, 167, 216, .06)',
		txt: 'rgba(7, 190, 184, .06)',
		img: 'rgba(53, 94, 255, .06)',
		url: 'transparent',
	};
	return {
		background: backObj[fileType.value] || 'rgba(114, 114, 152, .06)',
		padding: fileType.value == 'url' ? '20px 16px' : '13px 16px 13px',
		borderRadius: fileType.value == 'url' ? '0px' : '7px',
	};
});
</script>
  <style lang="scss" scoped>
.doc-detail {
	width: 360px;
	box-shadow: 0px 6px 20px 0px rgba(30, 64, 175, 0.15);
	border-radius: 8px;
	border: 2px solid #ffffff;
	max-height: 240px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	position: fixed;
	z-index: 1000;
	.refTitle {
		.source {
			color: var(--text-secondary);
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 6px;
			.left {
				display: flex;
				flex: 1 1;
				align-items: center;
				gap: 6px;
				max-width: 100%;
				&.notitle {
					max-width: calc(100% - 26px);
				}
			}
			.icon {
				flex-shrink: 0;
				width: 14px;
				height: 14px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 2px;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			.label {
				flex-grow: 1;
				line-height: 22px;
				font-size: 12px;
				color: #9a99aa;
			}
		}
		.defaultURlIcon{
			display: flex;
			align-items:center;
			.icon{
				padding:3px;
			  border-radius:50%;
			  background-color:#355EFF;
			  display:flex;
			  align-items:center;
				justify-content:center;
			}
			.link{
				margin-left: 4px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 12px;
        color: #9A99AA;
			}
		


		}
		.titleLine {
			display: flex;
			width: 100%;
			// justify-content: space-between;
			align-items: center;
			.title {
				max-width: 90%;
				line-height: 22px;
				display: block;
				text-decoration: none;
				font-weight: 500;
				font-size: 16px;
				color: #181b49;
				transition: all 0.3s;
				letter-spacing: 0px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				cursor: pointer;
				border-bottom: 1px solid transparent;
				box-sizing: content-box;
				&:hover {
					// color: blue;
					border-bottom: 1px solid #181b49;
				}
			}
			.arrow{
				margin-left: 5px;
			}
			.icon {
				font-size: 20px;
			}
		}
	}
	.content {
		// margin-top: -10px;
		padding: 0px 16px 11px;
		height: calc(100% - 80px);
		font-size: 14px;
		line-height: 1.6em;
		color: #646479;
		overflow-y: auto;
		overflow-x: hidden;
		:deep(em) {
			color: #355eff;
			font-style: normal;
		}
		.source-img{
			margin-top: 8px;
		}
	}
	.docContent{
		margin-top:7px;
	}
	.bgc-logo {
		position: absolute;
		top: 12px;
		right: 21px;
		z-index: -1;
		img {
			width: auto;
			height: 48px;
		}
	}
	.smalllogo {
		top: 7px;
		right: 15px;
		img {
			height: 40px !important;
		}
	}
}
.mobileDocDetail{
	width: 90%;
	max-width: 360px;
}
</style>